module.exports = __webpack_public_path__ + "static/media/apple-download-dark.2a409558.svg";